var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.type },
    [
      _vm.type == "mobile-info"
        ? [
            _c("div", { class: { removeActive: _vm.removeActive == true } }, [
              _c(
                "div",
                {
                  staticClass: "mobile-acc pointer",
                  class: { active: _vm.active == true },
                  style: _vm.top(_vm.index),
                  on: {
                    click: function ($event) {
                      return _vm.itemClick(_vm.index)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-row items-center justify-between pointer mobile-title container-fluid",
                    },
                    [
                      _vm._t("parent-nav-link"),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "w2 inline-flex pointer arrow-down-icon",
                          class: {
                            "is-clicked": _vm.mobileActive == _vm.index,
                            "is-navy": _vm.isInfoPage,
                          },
                        },
                        [
                          _c("simple-svg", {
                            staticClass: "green-arrow",
                            attrs: {
                              filepath: "/uploads/plus.svg",
                              id: "arrow-down-icon-id",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  ref: "mobileFAQsContainer",
                  staticClass:
                    "relative overflow-x-hidden overflow-y-scroll info-height mobile-info-height-container",
                  class: { active: _vm.active == true },
                },
                [
                  _c(
                    "transition",
                    {
                      on: {
                        beforeEnter: _vm.beforeEnter,
                        enter: _vm.enter,
                        leave: _vm.leave,
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.mobileActive == _vm.index,
                              expression: "mobileActive == index",
                            },
                          ],
                          staticClass: "info",
                          class: { active: _vm.mobileActive == _vm.index },
                        },
                        [_vm._t("sub-nav-links")],
                        2
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]
        : _vm.type == "desktop-info"
        ? [
            _c(
              "div",
              {
                staticClass: "mobile-info",
                class: { removeActive: _vm.removeActive == true },
                on: {
                  click: function ($event) {
                    _vm.active = !_vm.active
                  },
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "desktop-acc pointer",
                    class: { active: _vm.active == false },
                    on: {
                      click: function ($event) {
                        _vm.itemClick(_vm.index)
                        _vm.faqExpand()
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex flex-row items-center justify-between pointer",
                      },
                      [
                        _vm._t("parent-nav-link"),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "w2-ns w1 inline-flex pointer arrow-down-icon",
                            class: {
                              "is-clicked": _vm.mobileActive == _vm.index,
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "circle-plus closed",
                                class: { opened: _vm.active == false },
                              },
                              [_vm._m(0)]
                            ),
                          ]
                        ),
                      ],
                      2
                    ),
                  ]
                ),
                _vm._v(" "),
                !_vm.active
                  ? _c(
                      "div",
                      {
                        staticClass: "relative overflow-hidden info-height",
                        class: { active: _vm.mobileActive == _vm.index },
                      },
                      [
                        _c(
                          "transition",
                          {
                            on: {
                              beforeEnter: _vm.beforeEnter,
                              enter: _vm.enter,
                              leave: _vm.leave,
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.mobileActive == _vm.index,
                                    expression: "mobileActive == index",
                                  },
                                ],
                                staticClass: "info-slide",
                                class: {
                                  active: _vm.mobileActive == _vm.index,
                                },
                              },
                              [_vm._t("sub-nav-links")],
                              2
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
          ]
        : [
            _c(
              "div",
              {
                staticClass:
                  "flex flex-row items-center justify-between pointer acc-menu",
                class: { "": _vm.index !== 0 },
                on: {
                  click: function ($event) {
                    return _vm.itemClick(_vm.index, _vm.link)
                  },
                },
              },
              [
                _vm._t("parent-nav-link"),
                _vm._v(" "),
                _c("div", {
                  staticClass: "w2 inline-flex pointer arrow-down-icon",
                  class: { "is-clicked": _vm.desktopActive == _vm.index },
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c("transition", { attrs: { name: "slide-fade" } }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.desktopActive == _vm.index,
                      expression: "desktopActive == index",
                    },
                  ],
                  staticClass: "info relative",
                  class: { active: _vm.desktopActive == _vm.index },
                },
                [_vm._t("sub-nav-links")],
                2
              ),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "circle" }, [
      _c("div", { staticClass: "horizontal" }),
      _vm._v(" "),
      _c("div", { staticClass: "vertical" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }